import { render, staticRenderFns } from "./cloud_compute_big_data_course.vue?vue&type=template&id=da51f364&scoped=true&"
import script from "./cloud_compute_big_data_course.vue?vue&type=script&lang=js&"
export * from "./cloud_compute_big_data_course.vue?vue&type=script&lang=js&"
import style0 from "./cloud_compute_big_data_course.vue?vue&type=style&index=0&id=da51f364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da51f364",
  null
  
)

export default component.exports